import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { FormHelper } from '../../helpers/form-helper';
import { FbError } from '../../models/fbError';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent extends FormHelper implements OnInit, OnDestroy {

  constructor(private authService: AuthService,
							private formBuilder: FormBuilder,
							private router: Router) {
		super();

		this.buildForm();
	}

  ngOnInit() { }

	ngOnDestroy() { }

	public buildForm(): void {
		this.form = this.formBuilder.group({
			email: new FormControl('', [
				Validators.email,
				Validators.required
			])
		});
	}

	public async submitForm(): Promise<any> {
		try
		{
			let email: string = this.form.value.email;

			this.authService.resetPassword(email);

			this.submitError = '';
			this.router.navigate(['change-password']);
		}
		catch(ex)
		{
			let error = ex as FbError;

			switch (error.code) {
				case 'auth/invalid-email':
					this.submitError = 'El correo electrónico es incorrecto';
					break;

				case 'auth/user-not-found':
					this.submitError = 'El usuario no ha sido encontrado';
					break;

				default:
					this.submitError = 'Ocurrió un error al reiniciar la contraseña';
					break;
			}
		}
  }
}



// WEBPACK FOOTER //
// C:/Source/Ecim/Ecim.Web/src/app/components/reset-password/reset-password.component.ts